import { render, staticRenderFns } from "./HistoricalConfigFlowFilter.vue?vue&type=template&id=023f20ec&scoped=true&"
import script from "./HistoricalConfigFlowFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalConfigFlowFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f20ec",
  null
  
)

export default component.exports